import WarehouseIcon from '@mui/icons-material/Warehouse';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import StorefrontIcon from '@mui/icons-material/Storefront';

export const warehouseRelationDataConfig = (isFulfilment, dataTotals) => {
    return {
        orders:  {
            title: 'orders',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
            ...(dataTotals && {count: dataTotals.orders})
        },
        orderlogs:  {
            title: 'order_import',
            icon: <AssignmentReturnIcon/>,
            isSingleDataGrid: true,
            ...(dataTotals && {count: dataTotals.importOrderFailedCount})
        },
        inbounds:  {
            title: 'inbounds',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
            ...(dataTotals && {count: dataTotals.inbounds})
        },
        returns:  {
            title: 'returns',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
            ...(dataTotals && {count: dataTotals.returns})
        },
        products:  {
            title: 'products',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
            ...(dataTotals && {count: dataTotals.products})
        },
        virtualproducts:  {
            title: 'virtual_products',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
            ...(dataTotals && {count: dataTotals.virtualProducts})
        },
        invoices:  {
            title: 'invoices',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
            ...(dataTotals && {count: dataTotals.invoices})
        },
        financial:  {
            title: 'invoice_products',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
        },
        saleschannels:  {
            title: 'saleschannels',
            icon: <StorefrontIcon/>,
            isSingleDataGrid: true,
            ...(dataTotals && {count: dataTotals.saleschannels})
        },
        users:  {
            title: 'users',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
        },
        runners:  {
            title: 'runners',
            icon: <WarehouseIcon/>,
        },
        shelfwarmers:  {
            title: 'shelfwarmers',
            icon: <WarehouseIcon/>,
        }
    };
};
